import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=3ff6f0e8"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"
import style0 from "./FilesView.vue?vue&type=style&index=0&id=3ff6f0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports